<template>
<div class="footer">

</div>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    max-height: 25px;
}
</style>
